import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CreditIncreaseService } from '../credit-increase.service';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './loader.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './loader.component.scss',
})
export class LoaderComponent {
  constructor(public creditIncreaseService: CreditIncreaseService){

  }
}
